import { SocketStatus } from "@services/http/socket/WmSocket";
import { RootState } from "@store";

const migrations = {
  0: (state : RootState) => {
    return {
      ...state,
      Miners : [],
      Filters: {
        values: {
          f_admin_mine: false,
        }
      }
    }
  },
  1: (state : RootState) => {
    return {
      ...state,
      socket : {
        status : SocketStatus.OFF
      }
    }
  }
}

export default migrations;